import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { formatCurrency } from 'js/services/Format';
import ShipmentDashboardStore from 'js/stores/pages/AdminDashboardPage/ShipmentDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import Title from '../../DashPanel/Title';
import DropMenu from '../../DashPanel/DropMenu';
import Controls from '../../DashPanel/Controls';

import Link from './Link';
import GotoItem from './GotoItem';
import Date from './Date';
import Shipper from './Shipper';
import NotFound from './NotFound';
import Image from './Image';
import Path from './Path';

@observer
export default class Dashboard extends Component {
  shipmentDashboard = ShipmentDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.shipmentDashboard.load();
  }

  componentDidUpdate() {
    this.shipmentDashboard.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.shipmentDashboard.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Shipments</Title>
          <Controls>
            <Search model={this.shipmentDashboard} options={{ shipper: 'Shipper' }} />
            <Pagination model={this.shipmentDashboard} />
          </Controls>
        </Header>

        <Content>
          {this.shipmentDashboard.isLoading ? (
            <LoadingSpinner />
          ) : this.shipmentDashboard.shipments.length ? (
            <div>
              {this.shipmentDashboard.shipments.map(shipment => (
                <Link to={`shipment/${shipment.id}`} key={shipment.id}>
                  <Image direction={shipment.direction} />
                  <Date>{shipment.updated_at}</Date>
                  <Path>
                    <div>
                      {shipment.human_direction} of {shipment.order_item} from {shipment.from_location} to{' '}
                      {shipment.to_location}
                    </div>
                  </Path>
                  <Shipper>
                    <div>
                      {shipment.shipper}, {formatCurrency(shipment.rate)} - {shipment.human_status}
                    </div>
                  </Shipper>
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No shipments found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
